import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto sm:px-6 lg:px-8 pt-8 pb-12" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6" }
const _hoisted_3 = { class: "flex p-6" }
const _hoisted_4 = { class: "flex-shrink-0 mr-6" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "flex flex-col justify-between" }
const _hoisted_7 = { class: "text-xl font-semibold text-white mb-1" }
const _hoisted_8 = { class: "text-sm text-zinc-400" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "grid grid-cols-1 gap-5 pt-4" }
const _hoisted_11 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_12 = {
  key: 0,
  class: "rounded-xl border border-white/[0.07] bg-zinc-900/70 overflow-hidden"
}
const _hoisted_13 = { class: "max-h-[380px] overflow-y-auto x-steps-scroll px-4 py-4" }
const _hoisted_14 = { class: "flex flex-col items-center flex-shrink-0" }
const _hoisted_15 = {
  key: 0,
  class: "x-step-connector flex-1 w-px mt-1.5"
}
const _hoisted_16 = { class: "text-sm font-semibold text-white leading-snug mb-1" }
const _hoisted_17 = { class: "text-xs text-zinc-400 leading-relaxed mb-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "bg-zinc-950 overflow-hidden relative" }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = {
  key: 1,
  class: "space-y-4 pt-2"
}
const _hoisted_23 = { class: "space-y-3" }
const _hoisted_24 = { class: "flex items-center space-x-2" }
const _hoisted_25 = { class: "flex-1 relative" }
const _hoisted_26 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_27 = {
  key: 1,
  class: "w-4 h-4 text-green-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_28 = { class: "ml-1.5 text-xs font-medium" }
const _hoisted_29 = { class: "space-y-2" }
const _hoisted_30 = { class: "flex items-center space-x-2" }
const _hoisted_31 = {
  key: 0,
  class: "space-y-2 pl-6"
}
const _hoisted_32 = { class: "flex items-center space-x-2" }
const _hoisted_33 = {
  key: 1,
  class: "space-y-2 pl-6"
}
const _hoisted_34 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_35 = { class: "space-y-3" }
const _hoisted_36 = { class: "flex items-center space-x-2" }
const _hoisted_37 = { class: "flex-1 relative" }
const _hoisted_38 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_39 = {
  key: 1,
  class: "w-4 h-4 text-green-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_40 = { class: "ml-1.5 text-xs font-medium" }
const _hoisted_41 = { class: "space-y-4 pt-2" }
const _hoisted_42 = { class: "flex items-center space-x-2" }
const _hoisted_43 = { class: "flex items-center space-x-2" }
const _hoisted_44 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_45 = { class: "space-y-3" }
const _hoisted_46 = { class: "flex items-center space-x-2" }
const _hoisted_47 = { class: "flex-1 relative" }
const _hoisted_48 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_49 = {
  key: 1,
  class: "w-4 h-4 text-green-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_50 = { class: "ml-1.5 text-xs font-medium" }
const _hoisted_51 = { class: "space-y-4 pt-2" }
const _hoisted_52 = { class: "flex items-center space-x-2" }
const _hoisted_53 = { class: "flex items-center space-x-2" }
const _hoisted_54 = {
  key: 4,
  class: "space-y-6"
}
const _hoisted_55 = { class: "space-y-3" }
const _hoisted_56 = { class: "flex items-center space-x-2" }
const _hoisted_57 = { class: "flex-1 relative" }
const _hoisted_58 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_59 = {
  key: 1,
  class: "w-4 h-4 text-green-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_60 = { class: "ml-1.5 text-xs font-medium" }
const _hoisted_61 = { class: "space-y-2" }
const _hoisted_62 = { class: "flex items-center space-x-2" }
const _hoisted_63 = {
  key: 0,
  class: "space-y-2 pl-6"
}
const _hoisted_64 = { class: "flex items-center space-x-2" }
const _hoisted_65 = {
  key: 1,
  class: "space-y-2 pl-6"
}
const _hoisted_66 = { class: "bg-zinc-800 rounded-t-xl px-4 py-2.5 flex items-center gap-1.5 border border-white/[0.08] border-b-zinc-700" }
const _hoisted_67 = ["src"]

import { computed, ref } from 'vue';
import { Loader2 } from 'lucide-vue-next';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogScrollContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/toast';
import { Checkbox } from '@/components/ui/checkbox';
import { useBot } from '@/composables/useBot';
import { useIntegration } from '@/composables/useIntegration';
import { IntegrationProviderEnum } from '@/enums/integrations/IntegrationProviderEnum';

// ── Estado reativo ─────────────────────────────────────────────────

export default /*@__PURE__*/_defineComponent({
  __name: 'IntegrationView',
  setup(__props) {

const { selectedBot } = useBot()
const { getByProvider, save } = useIntegration()
const showDialog = ref(false);
const selectedIntegration = ref<any>(null);
const isLoading = ref(false);
const isSaving = ref(false);
const linkCopied = ref(false);

// Tutorial X
const showXTutorial = ref(false);
const lightboxImage = ref<string | null>(null);

const botTrackingLink = computed(() => {
  return `https://bot.mybotexpress.com/${selectedBot.value?.uuid}`
});

// ── Tutorial steps ─────────────────────────────────────────────────
const xTutorialSteps = [
  {
    title: 'Acesse o Gerenciador de Eventos',
    description: 'Em ads.x.com, no menu lateral em "Ferramentas", clique em "Gerenciador de eventos".',
    image: '/img/integrations/x/x-events-manager.png',
  },
  {
    title: 'Clique em "Install Pixel"',
    description: 'Na tela do gerenciador, clique no botão "Install Pixel" no canto superior direito.',
    image: '/img/integrations/x/x-install-pixel.png',
  },
  {
    title: 'Selecione "Manual" e continue',
    description: 'Escolha "Manual" para instalar via código ou Conversion API e clique em "Continuar".',
    image: '/img/integrations/x/x-manual.png',
  },
  {
    title: 'Selecione "Conversion API"',
    description: 'Escolha "Conversion API" para enviar eventos diretamente do servidor e clique em "Continuar".',
    image: '/img/integrations/x/x-conversion-api.png',
  },
  {
    title: 'Copie o Access Token e o Pixel ID',
    description: 'Copie o Access Token gerado. O Pixel ID aparece na URL do endpoint, após "/conversions/".',
    image: '/img/integrations/x/x-access-token-pixel-id.png',
  },
] as const;

// ── Integrações ────────────────────────────────────────────────────
const integrations = ref([
  {
    provider: IntegrationProviderEnum.UTMIFY,
    name: 'UTMify',
    logo: '/assets/integrations/utmify-logo.jfif',
    description: 'Gere UTMs automaticamente e rastreie suas campanhas',
    connected: false,
    fields: [
      {
        id: 'accessToken',
        label: 'Token de acesso',
        type: 'text',
        placeholder: 'Digite seu token de API',
        color: '#6b21a8'
      }
    ],
    data: {},
    buttonText: 'Salvar'
  },
  {
    provider: IntegrationProviderEnum.TWITTER,
    name: 'X',
    logo: '/assets/integrations/x.png',
    description: 'Rastreie conversões e otimize campanhas no X',
    connected: false,
    fields: [
      {
        id: 'accessToken',
        label: 'Access Token',
        type: 'text',
        placeholder: 'Access Token no X Ads Manager',
        color: '#000000'
      },
      {
        id: 'pixelId',
        label: 'Pixel ID',
        type: 'text',
        placeholder: 'Pixel ID no X Ads Manager',
        color: '#000000'
      },
    ],
    data: {
      enablePageView: false,
      enableInitiateCheckout: false
    },
    buttonText: 'Salvar'
  },
  {
    provider: IntegrationProviderEnum.META,
    name: 'Pixel Meta',
    logo: '/assets/integrations/meta-logo-icon.png',
    description: 'Monitore conversões e otimize suas campanhas',
    connected: false,
    fields: [
      {
        id: 'accessToken',
        label: 'Token de acesso',
        type: 'text',
        placeholder: 'Digite seu token de API',
        color: '#6b21a8'
      },
      {
        id: 'pixelId',
        label: 'Pixel ID',
        type: 'text',
        placeholder: 'Digite seu Pixel ID',
        color: '#6b21a8'
      }
    ],
    data: {
      enablePageView: false,
      enableInitiateCheckout: false
    },
    buttonText: 'Salvar'
  },
  {
    provider: IntegrationProviderEnum.TIKTOK,
    name: 'TikTok Ads',
    logo: '/img/integrations/tiktok/tiktok-icon.png',
    description: 'Rastreie conversões e otimize campanhas no TikTok',
    connected: false,
    fields: [
      {
        id: 'accessToken',
        label: 'Access Token',
        type: 'text',
        placeholder: 'Access Token no TikTok Events Manager',
        color: '#000000'
      },
      {
        id: 'pixelCode',
        label: 'Pixel Code',
        type: 'text',
        placeholder: 'Pixel Code no TikTok Events Manager',
        color: '#000000'
      }
    ],
    data: {
      enablePageView: false,
      enableInitiateCheckout: false
    },
    buttonText: 'Salvar'
  },
  {
    provider: IntegrationProviderEnum.KWAI,
    name: 'Kwai Ads',
    logo: '/img/integrations/kwai-icon.svg',
    description: 'Rastreie conversões e otimize campanhas no Kwai',
    connected: false,
    fields: [],
    data: {
      enablePageView: false,
      enableInitiateCheckout: false
    },
    buttonText: 'Salvar'
  }
]);

// Kwai temporariamente oculto do grid de integrações
const visibleIntegrations = computed(() => integrations.value.filter(integration => integration.provider !== IntegrationProviderEnum.KWAI))

// ── Métodos ────────────────────────────────────────────────────────
const openIntegrationDialog = async (integration: typeof integrations.value[0]) => {
  const fields: Record<string, string> = {}
  for (const field of integration.fields) {
    fields[field.id] = ''
  }
  selectedIntegration.value = integration
  showDialog.value = true
  showXTutorial.value = false
  lightboxImage.value = null
  isLoading.value = true
  selectedIntegration.value!.data = (await getByProvider(integration.provider))?.data ?? fields
  isLoading.value = false
};

const copyBotLink = async () => {
  try {
    await navigator.clipboard.writeText(botTrackingLink.value);
    linkCopied.value = true;
    toast({
      title: 'Link copiado com sucesso!',
      description: 'O link do bot foi copiado para a área de transferência.',
      class: 'bg-emerald-500 text-white',
      duration: 2000
    });
    setTimeout(() => { linkCopied.value = false; }, 2000);
  } catch {
    toast({
      title: 'Erro ao copiar',
      description: 'Não foi possível copiar o link. Tente selecionar e copiar manualmente.',
      class: 'bg-red-500 text-white',
      duration: 3000
    });
  }
};

const selectBotLink = (event: Event) => {
  const input = event.target as HTMLInputElement;
  input.select();
};

const handleSave = async () => {
  const data = selectedIntegration.value!.data
  if (!selectedIntegration.value) return;
  isSaving.value = true;
  await save({ data: data, provider: selectedIntegration.value!.provider })
  isSaving.value = false;
  toast({
    title: 'Integração salva com sucesso',
    class: 'bg-green-500 text-white',
    duration: 1500
  });
  showDialog.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mb-8" }, [
          _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-3" }, "Integrações"),
          _createElementVNode("p", { class: "text-[#9CA3AF] leading-relaxed text-sm" }, "Conecte suas ferramentas favoritas e automatize seus fluxos de trabalho.")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleIntegrations.value, (integration) => {
            return (_openBlock(), _createElementBlock("div", {
              key: integration.provider,
              class: "bg-white/5 rounded-xl overflow-hidden transition-all duration-200"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: integration.logo,
                    alt: integration.name,
                    class: "w-20 h-20 object-contain"
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(integration.name), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(integration.description), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (openIntegrationDialog(integration)),
                    class: "mt-4 px-4 py-2 bg-emerald-500 text-white rounded-md hover:bg-emerald-600 transition-colors duration-200 text-sm font-medium"
                  }, _toDisplayString(integration.connected ? 'Gerenciar conexão' : 'Vincular conta'), 9, _hoisted_9)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_unref(Dialog), {
        open: showDialog.value,
        "onUpdate:open": _cache[16] || (_cache[16] = ($event: any) => ((showDialog).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogScrollContent), {
            class: _normalizeClass([
          'transition-all duration-300',
          selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).TWITTER || selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).TIKTOK || selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).KWAI ? 'sm:max-w-lg' : 'sm:max-w-md'
        ])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Integre com o " + _toDisplayString(selectedIntegration.value?.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "w-full",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("form", {
                      onSubmit: _withModifiers(handleSave, ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        (selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).TWITTER)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (showXTutorial.value = !showXTutorial.value)),
                                class: _normalizeClass(["x-tutorial-toggle w-full flex items-center justify-between px-4 py-3 rounded-lg transition-all duration-200 group", showXTutorial.value ? 'x-tutorial-toggle--open' : ''])
                              }, [
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "flex items-center gap-2.5" }, [
                                  _createElementVNode("svg", {
                                    class: "w-4 h-4 text-zinc-400 flex-shrink-0 group-hover:text-emerald-400 transition-colors duration-200",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    })
                                  ]),
                                  _createElementVNode("span", { class: "text-sm font-medium text-zinc-300 group-hover:text-white transition-colors duration-200" }, " Como obter o Access Token e o Pixel ID? ")
                                ], -1)),
                                (_openBlock(), _createElementBlock("svg", {
                                  class: _normalizeClass(["w-4 h-4 text-zinc-500 flex-shrink-0 transition-transform duration-200", showXTutorial.value ? 'rotate-180' : '']),
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, _cache[21] || (_cache[21] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M19 9l-7 7-7-7"
                                  }, null, -1)
                                ]), 2))
                              ], 2),
                              _createVNode(_Transition, { name: "x-tutorial" }, {
                                default: _withCtx(() => [
                                  (showXTutorial.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(xTutorialSteps, (step, index) => {
                                            return _createElementVNode("div", {
                                              key: index,
                                              class: "flex gap-3.5"
                                            }, [
                                              _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0", index === xTutorialSteps.length - 1
                              ? 'bg-emerald-500/15 border border-emerald-500/30'
                              : 'bg-zinc-800 border border-white/[0.09]'])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["text-[10px] font-mono font-bold tabular-nums", index === xTutorialSteps.length - 1 ? 'text-emerald-400' : 'text-zinc-400'])
                                                  }, _toDisplayString(String(index + 1).padStart(2, '0')), 3)
                                                ], 2),
                                                (index < xTutorialSteps.length - 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex-1 min-w-0", index < xTutorialSteps.length - 1 ? 'pb-5' : 'pb-0.5'])
                                              }, [
                                                _createElementVNode("p", _hoisted_16, _toDisplayString(step.title), 1),
                                                _createElementVNode("p", _hoisted_17, _toDisplayString(step.description), 1),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  onClick: ($event: any) => (lightboxImage.value = step.image),
                                                  class: "x-screenshot-btn w-full text-left rounded-lg overflow-hidden border border-white/[0.07] transition-all duration-200 group cursor-zoom-in block"
                                                }, [
                                                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "bg-zinc-800/90 px-3 py-2 flex items-center gap-1.5 border-b border-white/[0.06]" }, [
                                                    _createElementVNode("div", { class: "w-2 h-2 rounded-full bg-zinc-600/80" }),
                                                    _createElementVNode("div", { class: "w-2 h-2 rounded-full bg-zinc-600/80" }),
                                                    _createElementVNode("div", { class: "w-2 h-2 rounded-full bg-zinc-600/80" }),
                                                    _createElementVNode("span", { class: "ml-2 text-[10px] font-mono text-zinc-500" }, "ads.x.com"),
                                                    _createElementVNode("span", { class: "ml-auto text-[10px] text-emerald-400/70 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200" }, " ampliar ↗ ")
                                                  ], -1)),
                                                  _createElementVNode("div", _hoisted_19, [
                                                    _createElementVNode("img", {
                                                      src: step.image,
                                                      alt: step.title,
                                                      class: "w-full h-auto object-cover block transition-transform duration-300 group-hover:scale-[1.012]",
                                                      loading: "lazy"
                                                    }, null, 8, _hoisted_20),
                                                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none" }, null, -1))
                                                  ])
                                                ], 8, _hoisted_18)
                                              ], 2)
                                            ])
                                          }), 64))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedIntegration.value?.fields, (field) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: field.id,
                            class: "space-y-2"
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_unref(Label), {
                                for: field.id,
                                class: "text-sm font-medium"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(field.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["for"])
                            ]),
                            _createVNode(_unref(Input), {
                              id: field.id,
                              type: field.type,
                              placeholder: field.placeholder,
                              modelValue: selectedIntegration.value!.data[field.id],
                              "onUpdate:modelValue": ($event: any) => ((selectedIntegration.value!.data[field.id]) = $event),
                              class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                            }, null, 8, ["id", "type", "placeholder", "modelValue", "onUpdate:modelValue"])
                          ]))
                        }), 128)),
                        (selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).TWITTER)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "bg-blue-500/10 border border-blue-500/20 rounded-lg p-4" }, [
                                _createElementVNode("div", { class: "flex items-start space-x-3" }, [
                                  _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("svg", {
                                      class: "w-5 h-5 text-blue-400 mt-0.5",
                                      fill: "currentColor",
                                      viewBox: "0 0 20 20"
                                    }, [
                                      _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                        "clip-rule": "evenodd"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "flex-1" }, [
                                    _createElementVNode("h4", { class: "text-sm font-medium text-blue-300 mb-1" }, "Configuração do Rastreamento"),
                                    _createElementVNode("p", { class: "text-xs text-blue-200/80 leading-relaxed" }, " Para que o rastreamento X/Twitter funcione corretamente, é necessário utilizar o link específico do bot abaixo em suas campanhas e automações. ")
                                  ])
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_unref(Label), { class: "text-sm font-medium text-white" }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("Link do Bot para Rastreamento")
                                  ])),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_unref(Input), {
                                      "model-value": botTrackingLink.value,
                                      readonly: "",
                                      class: "pr-10 text-gray-300 cursor-pointer select-all",
                                      onClick: selectBotLink
                                    }, null, 8, ["model-value"]),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-gray-400",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                        })
                                      ])
                                    ], -1))
                                  ]),
                                  _createVNode(_unref(Button), {
                                    type: "button",
                                    variant: "outline",
                                    size: "sm",
                                    onClick: copyBotLink,
                                    class: "px-3 py-2 bg-emerald-500/10 border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/20 hover:border-emerald-500/50 transition-all duration-200"
                                  }, {
                                    default: _withCtx(() => [
                                      (!linkCopied.value)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _cache[27] || (_cache[27] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                            }, null, -1)
                                          ])))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_27, _cache[28] || (_cache[28] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M5 13l4 4L19 7"
                                            }, null, -1)
                                          ]))),
                                      _createElementVNode("span", _hoisted_28, _toDisplayString(linkCopied.value ? 'Copiado!' : 'Copiar'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-xs text-gray-400" }, " Use este link em suas campanhas, automações e fluxos para garantir o rastreamento correto dos eventos. ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_unref(Label), {
                                  for: "twitterPurchaseEventId",
                                  class: "text-sm font-medium"
                                }, {
                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createTextVNode("ID do Evento Purchase")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_unref(Input), {
                                  id: "twitterPurchaseEventId",
                                  type: "text",
                                  placeholder: "ID do evento de Purchase no X Ads Manager",
                                  modelValue: selectedIntegration.value.data.purchaseEventId,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedIntegration.value.data.purchaseEventId) = $event)),
                                  class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_unref(Checkbox), {
                                  id: "twitterEnablePageView",
                                  checked: selectedIntegration.value.data.enablePageView,
                                  "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((selectedIntegration.value.data.enablePageView) = $event))
                                }, null, 8, ["checked"]),
                                _cache[31] || (_cache[31] = _createElementVNode("label", {
                                  for: "twitterEnablePageView",
                                  class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                }, " Habilitar evento PageView ", -1))
                              ]),
                              (selectedIntegration.value.data.enablePageView)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createVNode(_unref(Label), {
                                      for: "twitterPageViewEventId",
                                      class: "text-sm font-medium"
                                    }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode("ID do Evento PageView")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(Input), {
                                      id: "twitterPageViewEventId",
                                      type: "text",
                                      placeholder: "ID do evento de PageView no X Ads Manager",
                                      modelValue: selectedIntegration.value.data.pageViewEventId,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedIntegration.value.data.pageViewEventId) = $event)),
                                      class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_unref(Checkbox), {
                                  id: "twitterEnableInitiateCheckout",
                                  checked: selectedIntegration.value.data.enableInitiateCheckout,
                                  "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((selectedIntegration.value.data.enableInitiateCheckout) = $event))
                                }, null, 8, ["checked"]),
                                _cache[33] || (_cache[33] = _createElementVNode("label", {
                                  for: "twitterEnableInitiateCheckout",
                                  class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                }, " Habilitar evento InitiateCheckout ", -1))
                              ]),
                              (selectedIntegration.value.data.enableInitiateCheckout)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createVNode(_unref(Label), {
                                      for: "twitterInitiateCheckoutEventId",
                                      class: "text-sm font-medium"
                                    }, {
                                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                                        _createTextVNode("ID do Evento InitiateCheckout")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(Input), {
                                      id: "twitterInitiateCheckoutEventId",
                                      type: "text",
                                      placeholder: "ID do evento de InitiateCheckout no X Ads Manager",
                                      modelValue: selectedIntegration.value.data.initiateCheckoutEventId,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedIntegration.value.data.initiateCheckoutEventId) = $event)),
                                      class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).META)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "bg-blue-500/10 border border-blue-500/20 rounded-lg p-4" }, [
                                _createElementVNode("div", { class: "flex items-start space-x-3" }, [
                                  _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("svg", {
                                      class: "w-5 h-5 text-blue-400 mt-0.5",
                                      fill: "currentColor",
                                      viewBox: "0 0 20 20"
                                    }, [
                                      _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                        "clip-rule": "evenodd"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "flex-1" }, [
                                    _createElementVNode("h4", { class: "text-sm font-medium text-blue-300 mb-1" }, "Configuração do Rastreamento"),
                                    _createElementVNode("p", { class: "text-xs text-blue-200/80 leading-relaxed" }, " Para que o rastreamento Meta funcione corretamente, é necessário utilizar o link específico do bot abaixo em suas campanhas e automações. ")
                                  ])
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_unref(Label), { class: "text-sm font-medium text-white" }, {
                                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                                    _createTextVNode("Link do Bot para Rastreamento")
                                  ])),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_unref(Input), {
                                      "model-value": botTrackingLink.value,
                                      readonly: "",
                                      class: "pr-10 text-gray-300 cursor-pointer select-all",
                                      onClick: selectBotLink
                                    }, null, 8, ["model-value"]),
                                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-gray-400",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                        })
                                      ])
                                    ], -1))
                                  ]),
                                  _createVNode(_unref(Button), {
                                    type: "button",
                                    variant: "outline",
                                    size: "sm",
                                    onClick: copyBotLink,
                                    class: "px-3 py-2 bg-emerald-500/10 border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/20 hover:border-emerald-500/50 transition-all duration-200"
                                  }, {
                                    default: _withCtx(() => [
                                      (!linkCopied.value)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_38, _cache[38] || (_cache[38] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                            }, null, -1)
                                          ])))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_39, _cache[39] || (_cache[39] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M5 13l4 4L19 7"
                                            }, null, -1)
                                          ]))),
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(linkCopied.value ? 'Copiado!' : 'Copiar'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-xs text-gray-400" }, " Use este link em suas campanhas, automações e fluxos para garantir o rastreamento correto dos eventos. ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_unref(Checkbox), {
                                    id: "enablePageView",
                                    checked: selectedIntegration.value.data.enablePageView,
                                    "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((selectedIntegration.value.data.enablePageView) = $event))
                                  }, null, 8, ["checked"]),
                                  _cache[41] || (_cache[41] = _createElementVNode("label", {
                                    for: "enablePageView",
                                    class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                  }, " Habilitar evento PageView ", -1))
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _createVNode(_unref(Checkbox), {
                                    id: "enableInitiateCheckout",
                                    checked: selectedIntegration.value.data.enableInitiateCheckout,
                                    "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((selectedIntegration.value.data.enableInitiateCheckout) = $event))
                                  }, null, 8, ["checked"]),
                                  _cache[42] || (_cache[42] = _createElementVNode("label", {
                                    for: "enableInitiateCheckout",
                                    class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                  }, " Habilitar evento InitiateCheckout ", -1))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).TIKTOK)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "bg-blue-500/10 border border-blue-500/20 rounded-lg p-4" }, [
                                _createElementVNode("div", { class: "flex items-start space-x-3" }, [
                                  _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("svg", {
                                      class: "w-5 h-5 text-blue-400 mt-0.5",
                                      fill: "currentColor",
                                      viewBox: "0 0 20 20"
                                    }, [
                                      _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                        "clip-rule": "evenodd"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "flex-1" }, [
                                    _createElementVNode("h4", { class: "text-sm font-medium text-blue-300 mb-1" }, "Configuração do Rastreamento"),
                                    _createElementVNode("p", { class: "text-xs text-blue-200/80 leading-relaxed" }, " Para que o rastreamento TikTok funcione corretamente, é necessário utilizar o link específico do bot abaixo em suas campanhas e automações. ")
                                  ])
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_unref(Label), { class: "text-sm font-medium text-white" }, {
                                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                                    _createTextVNode("Link do Bot para Rastreamento")
                                  ])),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_unref(Input), {
                                      "model-value": botTrackingLink.value,
                                      readonly: "",
                                      class: "pr-10 text-gray-300 cursor-pointer select-all",
                                      onClick: selectBotLink
                                    }, null, 8, ["model-value"]),
                                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-gray-400",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                        })
                                      ])
                                    ], -1))
                                  ]),
                                  _createVNode(_unref(Button), {
                                    type: "button",
                                    variant: "outline",
                                    size: "sm",
                                    onClick: copyBotLink,
                                    class: "px-3 py-2 bg-emerald-500/10 border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/20 hover:border-emerald-500/50 transition-all duration-200"
                                  }, {
                                    default: _withCtx(() => [
                                      (!linkCopied.value)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_48, _cache[46] || (_cache[46] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                            }, null, -1)
                                          ])))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_49, _cache[47] || (_cache[47] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M5 13l4 4L19 7"
                                            }, null, -1)
                                          ]))),
                                      _createElementVNode("span", _hoisted_50, _toDisplayString(linkCopied.value ? 'Copiado!' : 'Copiar'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[48] || (_cache[48] = _createElementVNode("p", { class: "text-xs text-gray-400" }, " Use este link em suas campanhas, automações e fluxos para garantir o rastreamento correto dos eventos. ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createVNode(_unref(Checkbox), {
                                    id: "tiktokEnablePageView",
                                    checked: selectedIntegration.value.data.enablePageView,
                                    "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((selectedIntegration.value.data.enablePageView) = $event))
                                  }, null, 8, ["checked"]),
                                  _cache[49] || (_cache[49] = _createElementVNode("label", {
                                    for: "tiktokEnablePageView",
                                    class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                  }, " Habilitar evento ViewContent (visualização/lead) ", -1))
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createVNode(_unref(Checkbox), {
                                    id: "tiktokEnableInitiateCheckout",
                                    checked: selectedIntegration.value.data.enableInitiateCheckout,
                                    "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((selectedIntegration.value.data.enableInitiateCheckout) = $event))
                                  }, null, 8, ["checked"]),
                                  _cache[50] || (_cache[50] = _createElementVNode("label", {
                                    for: "tiktokEnableInitiateCheckout",
                                    class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                  }, " Habilitar evento InitiateCheckout ", -1))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (selectedIntegration.value?.provider === _unref(IntegrationProviderEnum).KWAI)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _cache[62] || (_cache[62] = _createElementVNode("div", { class: "bg-blue-500/10 border border-blue-500/20 rounded-lg p-4" }, [
                                _createElementVNode("div", { class: "flex items-start space-x-3" }, [
                                  _createElementVNode("div", { class: "flex-shrink-0" }, [
                                    _createElementVNode("svg", {
                                      class: "w-5 h-5 text-blue-400 mt-0.5",
                                      fill: "currentColor",
                                      viewBox: "0 0 20 20"
                                    }, [
                                      _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                        "clip-rule": "evenodd"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", { class: "flex-1" }, [
                                    _createElementVNode("h4", { class: "text-sm font-medium text-blue-300 mb-1" }, "Configuração do Rastreamento"),
                                    _createElementVNode("p", { class: "text-xs text-blue-200/80 leading-relaxed" }, " O Kwai não usa Access Token/Pixel ID — a atribuição é feita pelo link de rastreamento do bot abaixo (que carrega o clique do anúncio) combinado com os códigos de evento configurados no Kwai Ads Manager. ")
                                  ])
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_unref(Label), { class: "text-sm font-medium text-white" }, {
                                  default: _withCtx(() => _cache[52] || (_cache[52] = [
                                    _createTextVNode("Link do Bot para Rastreamento")
                                  ])),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _createVNode(_unref(Input), {
                                      "model-value": botTrackingLink.value,
                                      readonly: "",
                                      class: "pr-10 text-gray-300 cursor-pointer select-all",
                                      onClick: selectBotLink
                                    }, null, 8, ["model-value"]),
                                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-gray-400",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                        })
                                      ])
                                    ], -1))
                                  ]),
                                  _createVNode(_unref(Button), {
                                    type: "button",
                                    variant: "outline",
                                    size: "sm",
                                    onClick: copyBotLink,
                                    class: "px-3 py-2 bg-emerald-500/10 border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/20 hover:border-emerald-500/50 transition-all duration-200"
                                  }, {
                                    default: _withCtx(() => [
                                      (!linkCopied.value)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_58, _cache[54] || (_cache[54] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                            }, null, -1)
                                          ])))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_59, _cache[55] || (_cache[55] = [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M5 13l4 4L19 7"
                                            }, null, -1)
                                          ]))),
                                      _createElementVNode("span", _hoisted_60, _toDisplayString(linkCopied.value ? 'Copiado!' : 'Copiar'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-xs text-gray-400" }, " Use este link em suas campanhas do Kwai Ads para garantir que o clique (callback) seja capturado e o rastreamento funcione. ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createVNode(_unref(Label), {
                                  for: "kwaiPurchaseEventType",
                                  class: "text-sm font-medium"
                                }, {
                                  default: _withCtx(() => _cache[57] || (_cache[57] = [
                                    _createTextVNode("Código do Evento de Compra")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_unref(Input), {
                                  id: "kwaiPurchaseEventType",
                                  type: "number",
                                  placeholder: "event_type do evento de Compra no Kwai Ads Manager",
                                  modelValue: selectedIntegration.value.data.purchaseEventType,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedIntegration.value.data.purchaseEventType) = $event)),
                                  class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createVNode(_unref(Checkbox), {
                                  id: "kwaiEnablePageView",
                                  checked: selectedIntegration.value.data.enablePageView,
                                  "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((selectedIntegration.value.data.enablePageView) = $event))
                                }, null, 8, ["checked"]),
                                _cache[58] || (_cache[58] = _createElementVNode("label", {
                                  for: "kwaiEnablePageView",
                                  class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                }, " Habilitar evento de visualização/lead ", -1))
                              ]),
                              (selectedIntegration.value.data.enablePageView)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _createVNode(_unref(Label), {
                                      for: "kwaiPageViewEventType",
                                      class: "text-sm font-medium"
                                    }, {
                                      default: _withCtx(() => _cache[59] || (_cache[59] = [
                                        _createTextVNode("Código do Evento de Visualização")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(Input), {
                                      id: "kwaiPageViewEventType",
                                      type: "number",
                                      placeholder: "event_type do evento de visualização no Kwai Ads Manager",
                                      modelValue: selectedIntegration.value.data.pageViewEventType,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedIntegration.value.data.pageViewEventType) = $event)),
                                      class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_64, [
                                _createVNode(_unref(Checkbox), {
                                  id: "kwaiEnableInitiateCheckout",
                                  checked: selectedIntegration.value.data.enableInitiateCheckout,
                                  "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((selectedIntegration.value.data.enableInitiateCheckout) = $event))
                                }, null, 8, ["checked"]),
                                _cache[60] || (_cache[60] = _createElementVNode("label", {
                                  for: "kwaiEnableInitiateCheckout",
                                  class: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
                                }, " Habilitar evento InitiateCheckout ", -1))
                              ]),
                              (selectedIntegration.value.data.enableInitiateCheckout)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    _createVNode(_unref(Label), {
                                      for: "kwaiInitiateCheckoutEventType",
                                      class: "text-sm font-medium"
                                    }, {
                                      default: _withCtx(() => _cache[61] || (_cache[61] = [
                                        _createTextVNode("Código do Evento InitiateCheckout")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(Input), {
                                      id: "kwaiInitiateCheckoutEventType",
                                      type: "number",
                                      placeholder: "event_type do evento de InitiateCheckout no Kwai Ads Manager",
                                      modelValue: selectedIntegration.value.data.initiateCheckoutEventType,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedIntegration.value.data.initiateCheckoutEventType) = $event)),
                                      class: "rounded-lg border-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(Button), {
                          type: "submit",
                          class: "text-white",
                          disabled: isSaving.value || !selectedIntegration.value?.data
                        }, {
                          default: _withCtx(() => [
                            (isSaving.value)
                              ? (_openBlock(), _createBlock(_unref(Loader2), {
                                  key: 0,
                                  class: "w-4 h-4 animate-spin"
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(selectedIntegration.value?.buttonText || 'Salvar'), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ], 32)
                  ]))
                : (_openBlock(), _createBlock(_unref(Loader2), {
                    key: 1,
                    class: "w-10 h-10 animate-spin text-white mx-auto mt-4"
                  }))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "x-lightbox" }, {
        default: _withCtx(() => [
          (lightboxImage.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[19] || (_cache[19] = ($event: any) => (lightboxImage.value = null)),
                class: "fixed inset-0 z-[9999] flex items-center justify-center p-6 cursor-zoom-out",
                style: {"background":"rgba(0,0,0,0.88)","backdrop-filter":"blur(6px)"}
              }, [
                _createElementVNode("div", {
                  class: "relative w-full max-w-3xl",
                  onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_66, [
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-zinc-600" }, null, -1)),
                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-zinc-600" }, null, -1)),
                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-zinc-600" }, null, -1)),
                    _cache[67] || (_cache[67] = _createElementVNode("span", { class: "ml-2.5 text-xs font-mono text-zinc-500" }, "ads.x.com", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (lightboxImage.value = null)),
                      class: "ml-auto w-6 h-6 rounded-md bg-zinc-700 hover:bg-zinc-600 flex items-center justify-center transition-colors duration-150 cursor-pointer"
                    }, _cache[63] || (_cache[63] = [
                      _createElementVNode("svg", {
                        class: "w-3.5 h-3.5 text-zinc-300",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("img", {
                    src: lightboxImage.value,
                    alt: "Screenshot",
                    class: "w-full h-auto rounded-b-xl border border-white/[0.08] border-t-0 block",
                    style: {"max-height":"80vh","object-fit":"contain"}
                  }, null, 8, _hoisted_67)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}
}

})